import { UserTranslationsForm } from './user-translations-form';

const UserTranslations = () => <UserTranslationsForm />;

export default UserTranslations;
